import React, { useEffect } from 'react';
import { Box } from '@mui/system';
import { IconButton } from 'components/Buttons/IconButton';
import pxToEm from 'theme/pxToEm';
import * as Styled from './LetterPicker.styles';
import { Props } from './LetterPicker.types';

export const SortingLetters = [
  '0-9',
  'A',
  'B',
  'C',
  'D',
  'E',
  'F',
  'G',
  'H',
  'I',
  'J',
  'K',
  'L',
  'M',
  'N',
  'O',
  'P',
  'Q',
  'R',
  'S',
  'T',
  'U',
  'V',
  'W',
  'X',
  'Y',
  'Z',
];
const scrollWidth = 96;

enum ActionDirection {
  LEFT = 'left',
  RIGHT = 'right',
}

const LetterPicker: React.FC<Props> = ({
  onLetterPressed,
  availableLetters,
  activeLetter,
  showActions = false,
}) => {
  const scrollContainerRef = React.useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (scrollContainerRef?.current != null && activeLetter != null) {
      const letterButton = document.getElementById(`letter_${activeLetter}`);
      if (letterButton != null) {
        const position =
          letterButton.offsetLeft +
          letterButton.offsetWidth -
          window.innerWidth / 2;
        scrollContainerRef.current.scrollTo({
          left: position,
          behavior: 'smooth',
        });
      }
    }
  }, [activeLetter]);

  const hanldeActionClick = (direction: ActionDirection) => {
    if (!scrollContainerRef.current) return;

    const currentLeftPosition = scrollContainerRef.current?.scrollLeft;
    const newScrollLeft =
      direction === 'left'
        ? currentLeftPosition - scrollWidth
        : currentLeftPosition + scrollWidth;

    scrollContainerRef.current?.scroll({
      left: newScrollLeft,
      behavior: 'smooth',
    });
  };

  const actionsJSX = (
    <Box
      display="flex"
      flexDirection="row"
      justifyContent="flex-end"
      columnGap={pxToEm(12)}
      marginRight={pxToEm(31)}
    >
      <IconButton
        iconName="arrow-left"
        size="medium"
        dense={true}
        color="secondary"
        onClick={() => hanldeActionClick(ActionDirection.LEFT)}
      />
      <IconButton
        iconName="arrow-right"
        size="medium"
        dense={true}
        color="secondary"
        onClick={() => hanldeActionClick(ActionDirection.RIGHT)}
      />
    </Box>
  );

  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="flex-start"
      rowGap={pxToEm(22)}
    >
      {showActions && actionsJSX}
      <Box width="100%" position="relative">
        <Styled.ScrollContainer
          ref={scrollContainerRef}
          className="letterScrollWrapper"
        >
          {SortingLetters.map((letter) => {
            const isInactive = !availableLetters?.includes(letter);
            const isSelected =
              letter.toLocaleLowerCase() ===
                String(activeLetter).toLocaleLowerCase() && !isInactive;
            return (
              <Styled.Item
                id={`letter_${letter}`}
                data-testid={`letter_${letter}`}
                active={isSelected}
                display="flex"
                onClick={() => onLetterPressed(letter)}
                key={letter}
                unactive={isInactive}
              >
                <Styled.Letter variant="body">{letter}</Styled.Letter>
              </Styled.Item>
            );
          })}
        </Styled.ScrollContainer>
      </Box>
    </Box>
  );
};

export default LetterPicker;
